import React, { Component } from "react";
import { Container, Tabs, Tab } from "react-bootstrap";
import { connect } from "react-redux";
import { SuperAdminAction } from "../../Actions";
import CashoutMeter from "./total_cashout_meter";
import CashoutAmount from "./amount_cashout";
import CashoutHistory from "./cashout_history";

class CashoutReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
    };
  }

  onTabClick = async (k) => {
    this.setState({ activeTab: k });
  };

  render() {
    return (
      <>
        <Container fluid>
          <Tabs activeKey={this.state.activeTab} id="controlled-tab-example" onSelect={(k) => this.onTabClick(k)} transition={false}>
            <Tab eventKey="1" className="m-0" title="Cashout Amount">
              {this.state.activeTab === "1" && <CashoutAmount />}
            </Tab>
            <Tab eventKey="2" className="m-0" title="Total Cashout Meter">
              {this.state.activeTab === "2" && <CashoutMeter />}
            </Tab>
            <Tab eventKey="3" className="m-0" title="Cashout History">
              {this.state.activeTab === "3" && <CashoutHistory />}
            </Tab>
          </Tabs>
        </Container>
      </>
    );
  }
}

const mapStateToProps = ({ UserProfileDetails, Logindetails }) => {
  const { property_id: PropertyId, user_type, suite_id, timezone, property } = UserProfileDetails;
  const { backgroundColor } = Logindetails;

  const { MainBackground: main_body } = backgroundColor;
  return {
    PropertyId,
    user_type,
    suite_id,
    timezone,
    property,
    main_body,
  };
};

const mapStateToDispatch = {
  setDomainHeader: SuperAdminAction.setDomainHeader,
};

export default connect(mapStateToProps, mapStateToDispatch)(CashoutReport);
